import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs";
import { MICustomFunctionsParams } from "../../../models/fields/custom-function-params";
import { MCFormisFieldAutoCompleteService, MCUnionRequestHttpWrapperService, MCUtils } from "@maslul/common-services";
import { ApprovalTypeData } from "../../approval-type/approvals-type-data";
import { RequestApprovalTypeDetailsStore } from "../../store/approval-type-details-store";

@Injectable({
    providedIn: 'root'
})
export class ManufacturersFunctions {
    text: any;
    constructor(
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private translateService: TranslateService,
    ) {
        this.setLangSettings();
    }

    //check this: manufacturerRegex = /^(?=.*[a-zA-Z0-9!@#?$%^&*(),\/;+='"\\._-])[a-zA-Z0-9 !@#?$%^&*(),\/;+='"\\._-]+$/;
    // eslint-disable-next-line no-useless-escape
    manufacturerRegex = new RegExp('^(?=.*[a-zA-Z0-9!@#?\$%\^\&*\)\(:,\\\/\;+=\'\"._-])[a-zA-Z0-9 !@#?\$%\^\&*\)\(:,\\\/\;+=\'\"._-]+$');

    setLangSettings() {
        this.text = this.translateService.instant("unionRequest.itemsDetails.rowItem");
    }


    updateManufacturerNameFromValues(customFunctionsObj: MICustomFunctionsParams) {
        const manufactureNameObject = customFunctionsObj.formisForm.
            model?.manufacturersDetails?.manufacturerDetails[customFunctionsObj.index || 0].manufacturerObject || {};
        const manufacturerValue = manufactureNameObject?.label ||
            (MCUtils.isEmptyObject(manufactureNameObject) ? undefined : manufactureNameObject) ||
            "";

        if (this.manufacturerRegex.test(manufacturerValue)) {
            customFunctionsObj.formisForm.fields?.find(x => x.key == 'manufacturersDetails')
                ?.fieldGroup?.find(x => x.key == 'manufacturerDetails')
                ?.fieldGroup?.[customFunctionsObj.index || 0]?.fieldGroup
                ?.find(x => x.key == "manufacturer")?.formControl
                ?.setValue(
                    manufacturerValue
                );
        }

    }

    fillManufacturerList(customFunctionsObj: MICustomFunctionsParams) {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        const injector = customFunctionsObj.injector;
        const httpWrapperService = injector.get(MCUnionRequestHttpWrapperService<any>);
        const formisFieldAutoCompleteService = customFunctionsObj.injector.get(MCFormisFieldAutoCompleteService);
        const value = customFunctionsObj?.value;
        if (this.manufacturerRegex.test(value) && value?.length >= 2) {
            const apTypesForManufacturer = ApprovalTypeData.approvalOfManufacturerNameList
                .find(apArr => apArr.includes(parseInt(approvalTypeId))) || [];
            if (apTypesForManufacturer?.length == 0) { return; }
            httpWrapperService.getManufacturers(value,
                apTypesForManufacturer
            ).pipe(
                map((res: any) => {
                    return res.data;
                }))
                .subscribe((res) => {
                    const manufacturerDetails = customFunctionsObj?.formisForm?.fields
                        ?.find(x => x.key === "manufacturersDetails")?.fieldGroup
                        ?.find(x => x.key === "manufacturerDetails")?.fieldGroup;
                    const manufacturerObject = manufacturerDetails?.[customFunctionsObj.index || 0]
                        ?.fieldGroup?.find(field => field.key === "manufacturerObject");
                    if (manufacturerObject?.props) {
                        manufacturerObject.props.options = res?.map((item: any) => ({ value: item, label: item })) || [];
                    }
                    formisFieldAutoCompleteService.externalRefreshList.next(true);
                    console.log(res);
                });
        }
    }






}